import CircleToggleButton from "./CircleToggleButton";
import RangeGroupingLabelEditor from "./RangeGroupingLabelEditor";
import { Box, Tooltip, Typography } from "@mui/material";
import {
  RANGE_GROUPING_ENTRY_INDENT,
  RANGE_GROUPING_LABEL_MIN_HEIGHT,
} from "components/reportsV3/types/constants";
import * as labels from "config.labels";
import React, { useState } from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

export const RangeGroupingNoValueEntry = ({
  labelText,
  defaultLabel,
  labelOverride,
  active,
  isDuplicate,
  onLabelChange,
  onActivate,
}) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  const [anchor, setAnchor] = useState(null);
  const editLabel = translateLabels(
    labels.RANGE_GROUPING_DIALOG_EDIT_NO_VALUE_LABEL,
    { default: "Edit no value label" }
  );
  const nullTargetLabel = translateLabels(
    labels.RANGE_GROUPING_DIALOG_NULL_TARGET,
    { default: "Put rows with no value here" }
  );
  const labelLine = translateLabels(labels.RANGE_GROUPING_DIALOG_LABEL_LINE, {
    default: "{label}:",
    replacements: { label: labelText },
  });

  const handleLabelKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setAnchor(event.currentTarget);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: RANGE_GROUPING_LABEL_MIN_HEIGHT,
        }}
      >
        {active ? (
          <Tooltip title={editLabel}>
            <Typography
              variant={"body2"}
              role={"button"}
              tabIndex={0}
              aria-label={editLabel}
              color={isDuplicate ? "error" : undefined}
              sx={{ cursor: "pointer" }}
              onClick={(event) => setAnchor(event.currentTarget)}
              onKeyDown={handleLabelKeyDown}
            >
              {labelLine}
            </Typography>
          </Tooltip>
        ) : (
          <Typography variant={"body2"} color={"text.disabled"}>
            {labelLine}
          </Typography>
        )}
        <CircleToggleButton
          active={active}
          title={nullTargetLabel}
          onClick={() => onActivate()}
        />
      </Box>
      <RangeGroupingLabelEditor
        open={active && Boolean(anchor)}
        anchorEl={anchor}
        initialText={labelOverride ?? ""}
        placeholder={defaultLabel}
        onApply={(text) => onLabelChange(text)}
        onClose={() => setAnchor(null)}
      />
      <Box sx={{ pl: RANGE_GROUPING_ENTRY_INDENT }}>
        <Typography
          variant={"body2"}
          color={active ? undefined : "text.disabled"}
        >
          {translateLabels(labels.RANGE_GROUPING_DIALOG_NO_VALUE_TEXT, {
            default: "Where there is no value",
          })}
        </Typography>
      </Box>
    </Box>
  );
};

export default RangeGroupingNoValueEntry;
